export const reportStatusSchema = () => {
  return {
    Response: "",
    Reports: [],
    ToDoList: [ToDoListSchema()]
  };
};

export const reportSchema = (period = "", status = "") => {
  return {
    Period: period,
    // ExternalFactor: "",
    // InternalFactor: "",
    // Stratergies: "",
    Report: "",
    ReportSubmittedBy: "",
    reportSubmittedOn: null,
    ReportStatus: status
  };
};

export const statusActivitySchema = (name = "", status = "") => {
  return {
    CreatedBy: name,
    CreatedOn: new Date(),
    ReportStatus: status
  };
};

export const ToDoListSchema = () => {
  return {
    description: "",
    duedate: "",
    startdate: ""
  };
};

export const WebinarReportSchma = () => {
  return {
    Title: "",
    Date: new Date(),
    Presenter: "",
    Content: "",
    Questions: ""
  };
};

export const WebinarUserQuestionsSchma = () => {
  return {
    Questions: "",
    LastQuestionAsked: "",
    IsAnswered: false
  };
};
